import React from 'react';
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({
  menuItem: {
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    textDecoration: 'none',
    padding: theme.spacing.unit,
    fontSize: theme.spacing.unit * 1.6,
    textTransform: 'uppercase',
    '&:hover': {
      color: theme.palette.primary.light
    },
    '&:focus': {
      color: '#FFF'
    }
  }
});

export const CryptxMenu = withStyles(styles)(({classes, menuItems}) => (
  <div>
    {menuItems.map((menuItem, index) => (<a href={menuItem.link} key={index.toString()} className={classes.menuItem}>{menuItem.name}</a>))}
  </div>
));
